module.exports = __webpack_public_path__ + "files/678b9e9efb6c3cc8e123125dd3302edc.png";